<template>
    <content class="boty" menu="成果创新点"  :location = "['首页','成果创新点']"> 
        <view class="main-body">
            <view class="main-content">
                <view class="data">
                    <h1>成果创新点</h1>
                    <p><b>模式创新：构建起“学研产创一体，政校企融通”的“三四四”人才培养模式。</b></p>
                    <p>模式凸显了政府在政策引导和创新平台搭建中的作用，以及校企在合作过程中的主体地位，推动人才培养传统模式向“学研产创”一体化新模式转变。从2005年“草原季节”研创产品设计项目引入“产学研”理念，到2018年“布丝瑰行动计划”民族服饰设计研学基地项目建设，逐步建立起校企新型合伙人模式，完成“学研产创一体，政校企融通”的“三联合、四共建、四对接”的应用型人才培养“三四四”模式的转变。</p>
                    <p><b>体系创新：构建起一流专业建设为引领的设计类专业集群。</b></p>
                    <p>基于“新文科”建设，打通专业壁垒，立足内蒙古特色产业链，培育高素质应用型一专多能设计人才，积聚设计类专业集体优势，建成“地域与民族”特色鲜明的设计类专业集群，建设有设计学类2个国家级一流本科专业。</p>
                    <p>重构聚焦学生创新能力和民族服饰产业服务能力培养的课程新体系，突出专业交叉、传承与创新并重的特点，面向区域产业需求，动态调整课程模块设置，聚焦优秀传统服饰艺术活化，创新民族服饰设计实践与应用。</p>
                    <p><b>特色创新：重塑以服务意识和服务能力为导向的人才培养特色。</b></p>
                    <p>基于设计服务与产业融合发展的办学特色，发挥高校资源优势，坚持“立足内蒙古，面向边疆地区，辐射全国”，以实践基地、协同创新中心等创新平台为支撑，提升服务地方经济社会发展能力。把服务意识和服务能力培养融入人才培养体系中，形成具有社会责任、创新精神、实践能力、开放视野、职业操守的培养模式。此外，围绕内蒙古特色民族服饰文化开展挖掘、研究和传播工作，开发并挖掘民族服饰文化价值，以传承与创新为引擎，以市场为导向，与民族服饰企业实现产创一体，与民族文化相关产业实现跨界融合，从而推动传统工艺振兴和乡村振兴。2019年“布丝瑰”研学项目强化了“文化传承、设计振兴”主题，300余名师生创作民族文化设计产品1000余件，参选创新创业大赛作品70项，实现产品转化100余件，设计服务社会成果显著。</p>
                </view>
            </view>
        </view>	
    </content>
</template>


<script>
    import content from '../content.vue'
	export default {
		name:"achievement_innovate",
        components:{
            content,
        }
	}
</script>

<style lang="scss" scoped>

.data{
    margin-left: 20px;
    margin-bottom: 20px;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    
    font-family:"FangSong";
    h1{
        margin-top: 50px;
        margin-bottom: 20px;
        color: #333;
        font-size: 2ch;
        text-align: center;
        font-size: 3.2ch;
        font-weight: 800;
    }
    p{
        color: #333;
        font-weight: 550;
        line-height: 4ch;
        text-indent:30px;
        font-size: 2.4ch;
        margin:4px 0;
    }

    /*
    .image{
        display: flex;
        flex-direction: column;
        align-items: center;
        margin: 30px 0;
        image{
            margin: 10px 0;
            text-align: center;
        }
        text{
            margin: 10px 0;
            color: #999;
            font-size: 1.6ch;
        }
    }*/
}


</style>
